import { ChatMarkdown } from "@/core/components/chat-markdown";

// White, on a chrome that is no longer white.
//
// It used to be gray-5 on gray-0, which read as a bubble. Against the editor's
// darker ground that is 242 on 229 and all but disappears, so the owner's own
// words become the faintest thing in the conversation. On a workbench the
// things you put down are cards.
const BUBBLE =
  "ml-auto max-w-[85%] rounded-2xl rounded-br-md border border-stroke-tertiary bg-surface-primary px-3.5 py-2.5";

/**
 * One thing the owner said, however far along it is.
 *
 * Shared on purpose. A message on its way out and the same message once the
 * server has it are the same words in the same place, so they have to be the
 * same markup: the optimistic copy used a plain pre-wrapped paragraph while the
 * real one went through ChatMarkdown, and the bubble changed height and
 * wrapping the moment the request landed. Rendering both from here means the
 * swap is invisible, and the two cannot drift apart again.
 */
export const OwnerMessage = ({ children }: { children: string }) => (
  <div className={BUBBLE}>
    <ChatMarkdown>{children}</ChatMarkdown>
  </div>
);
